import styled from "@emotion/styled/macro";

export const InfoSec = styled.div`
    color: #656678;
    background: '#d9d9dd';
`

export const InfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: ${({ imgStart }) => (imgStart ? 'row-reverse' : 'row')};
`;

export const InfoColumn = styled.div`
  @media (min-width: 480px) and (max-width: 1200px) {
    max-width: 100%;
    flex-basis: 100%;
    display: flex;
    justify-content: center;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    max-width: 100%;
    flex-basis: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 10px;

  @media (min-width: 480px) and (max-width: 1200px) {
    fontSize : 20;
    max-width: 100px;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    fontSize : 20;
    max-width: 100px;
  }
`;

export const ImgWrapper = styled.div`
  max-width: 555px;
  display: flex;
  justify-content: ${({ start }) => (start ? 'flex-start' : 'flex-end')};
`;


export const TopLine = styled.div`
  color: ${({ lightTopLine }) => (lightTopLine ? '#a9b3c1' : '#4B59F7')};
  font-size: 18px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  margin-bottom: 16px;
`;

export const Img = styled.img`
  padding-right: 0;
  border: 0;
  max-width: 100%;
  vertical-align: middle;
  display: block;
  max-height: max-content;
`;

export const Heading = styled.h1`
  font-size : 48px;
  margin-bottom : 15px;
  margin-left : 25px;

  @media (min-width: 480px) and (max-width: 1200px) {
    font-size : 30px;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    font-size : 20px;
  }
`;

export const Subtitle = styled.p`
font-size : 18px;
margin-bottom : 30px;
margin-left : 75px;

@media (min-width: 480px) and (max-width: 1200px) {
  font-size : 20px;
}

@media (min-width: 320px) and (max-width: 480px) {
  font-size : 10px;
}
`;

export const Button = styled.button`
  border-radius: 4px;
  background: ${({ primary }) => (primary ? '#4B59F7' : '#0467FB')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '12px 64px' : '10px 20px')};
  color: #fff;
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  outline: none;
  border: none;
  cursor: pointer;
  margin-left : 25px;
  &:hover {
    transition: all 0.3s ease-out;
    background: #fff;
    background-color: ${({ primary }) => (primary ? '#0467FB' : '#4B59F7')};
  }
  @media screen and (max-width: 960px) {
    padding: 10px;  
    width: 100%;
  }
`;

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 0px;
  padding-left: 0px;
  @media screen and (max-width: 991px) {
    padding-right: 0px;
    padding-left: 0px;
  }
`;

export const AddToCart = styled.button`
  background-color: #ff6f00;
  color: white;
  padding: 5px 8px;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #e65c00;
  }

  &:active {
    background-color: #cc5200;
    transform: scale(0.98);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    color: #666;
  }
`;

export const BuyNow = styled.button`
  border-radius: 4px;
  background: ${({ primary }) => (primary ? '#4B59F7' : '#0467FB')};
  white-space: nowrap;
  padding: ${({ big, small }) =>
    small ? '6px 12px' : big ? '12px 64px' : '10px 20px'};
  color: #fff;
  font-size: ${({ fontBig, small }) =>
    small ? '14px' : fontBig ? '20px' : '16px'};
  outline: none;
  border: none;
  cursor: pointer;
  margin-left: 10px;

  &:hover {
    transition: all 0.3s ease-out;
    background: #fff;
    background-color: ${({ primary }) => (primary ? '#0467FB' : '#4B59F7')};
  }

  @media screen and (max-width: 960px) {
    padding: ${({ small }) => (small ? '6px 12px' : '10px')};
    width: 100%;
  }
`;

// Body styles
export const Body = styled.body`
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    background-color: #f4f7f9;
    display: flex;
    justify-content: center;
    align-items: center;
    // min-height: 100vh;
    margin: 0;
`;

// Card component
export const Card = styled.div`
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    width: 340px;
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`;

// Card header
export const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
`;

// Title area
export const TitleArea = styled.div`
    display: flex;
    align-items: center;
    
    h3 {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin: 0;
        
        &::before {
            content: '';
            display: inline-block;
            width: 50px;
            height: 50px;
            margin-right: 12px;
            vertical-align: middle;
            border-radius: 50%; /* circular border */
            padding: 2px;
            border: 2px solid #ccc; /* color of the circle border */
            
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(${props => props.iconSrc});
        }
    }
`;

// Price component
export const Price = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: #2c2c2c;
  white-space: nowrap;
  letter-spacing: -0.5px;

  span.currency {
    font-size: 18px;
    vertical-align: baseline;
    color: #777;
    margin-right: 4px;
  }

  span.decimal {
    font-size: 16px;
    color: #888;
    vertical-align: super;
    margin-left: 2px;
  }
`;

// Features list
export const FeaturesList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0 0 24px 0;
    border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
    
    li {
        padding: 12px 0;
        color: #555;
        position: relative;
        padding-left: 28px; /* 为勾选图标留出空间 */
        
        &::before {
            position: absolute;
            left: 0;
            top: 12px;
            color: #28a745; /* 绿色 */
            font-weight: bold;
        }
    }
`;

// Card actions
export const CardActions = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: auto; /* 使操作区域始终在卡片底部 */
`;

// Primary button
export const ButtonPrimary = styled.button`
    background-color: #007bff;
    color: #fff;
    border: none;
    padding: 12px 28px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
    
    &:hover {
        background-color: #0056b3;
    }
`;

// Details link
export const DetailsLink = styled.a`
    color: #007bff;
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    transition: color 0.2s ease-in-out;
    
    &:hover {
        color: #0056b3;
        text-decoration: underline;
    }
`;

export const FeatureContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

// This is the key component for the layout
export const FeatureItem = styled.li`
  display: flex;
  justify-content: space-between; /* Pushes children to opposite ends */
  align-items: center;           /* Vertically aligns them */
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

// You can create a styled component for the label group for consistency
export const LabelGroup = styled.div`
  display: flex;
  align-items: center;
  color: #555; /* Color for the label text */

  svg {
    margin-right: 12px; /* Space between icon and text */
    color: #007bff;     /* Color for the icon */
  }
`;

export const ValueSpan = styled.span`
  font-weight: 600;
  color: #1a1a1a;
`;